import {useState} from "react";
import ContainerService from "../services/api";
import {useSnackbar} from "notistack";
import {useNavigate} from "react-router-dom";
import useContainerStore from "../zustand/useContainerStore";

const useContainer = () => {
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();

    const {setContainerStatusUpdated} = useContainerStore();

    const [isFetchingContainerList, setFetchingContainerList] = useState(false);
    const [containerList, setContainerList] = useState([]);
    const [isListingContainer, setListingContainer] = useState(false);
    const [containerListWithPagination, setContainerListWithPagination] = useState([]);
    const [isCreatingContainer, setCreatingContainer] = useState(false);
    const [isFetchingContainerTypes, setFetchingContainerTypes] = useState(false);
    const [containerTypes, setContainerTypes] = useState([]);
    const [isViewingContainer, setViewingContainer] = useState(false);
    const [containerDetails, setContainerDetails] = useState(null);
    const [isUpdatingContainerStatus, setUpdatingContainerStatus] = useState(false);
    const [isFetchingContainerStatusList, setFetchingContainerStatusList] = useState(false);
    const [containerStatusList, setContainerStatusList] = useState([]);
    const [isUpdatingContainer, setUpdatingContainer] = useState(false);
    const [isFilteringContainer, setFilteringContainer] = useState(false);


    const getListContainer = (parameters) => {
        setFetchingContainerList(true);

        ContainerService.getListContainer(parameters).then((res) => {
            console.log("getListContainer data xxxx", res);

            if (res.data.success) {
                setFetchingContainerList(false);
                setContainerList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching container list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setContainerList([]);
            setFetchingContainerList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getListContainerWithPagination = (parameters) => {
        setListingContainer(true);
        setContainerStatusUpdated(false);

        ContainerService.getListContainerWithPagination(parameters).then((res) => {
            console.log("getListContainerWithPagination data xxxx", res);

            if (res.data.success) {
                setListingContainer(false);
                setContainerListWithPagination(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching container list with pagination:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setContainerListWithPagination([]);
            setListingContainer(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const createContainer = (payload, orgIdFromUrlForPortEmployee) => {
        setCreatingContainer(true);

        ContainerService.createContainer(payload).then((res) => {
            console.log("createContainer data xxxx", res);

            if (res.data.success) {
                setCreatingContainer(false);
                enqueueSnackbar("Successfully created container", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                if (orgIdFromUrlForPortEmployee) {
                    navigate(`/organization/view/containers/view?org_uid=${res.data.data.data.org_uid}&id=${res.data.data.data.container_uid}`);

                } else {
                    navigate(`/containers/view?id=${res.data.data.data.container_uid}`);
                }
            } 

        }).catch((error) => {
            console.error("Error creating container:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setCreatingContainer(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getContainerTypes = () => {
        setFetchingContainerTypes(true);

        ContainerService.getContainerTypes().then((res) => {
            console.log("getContainerTypes data xxxx", res);

            if (res.data.success) {
                setFetchingContainerTypes(false);
                setContainerTypes(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching container types:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setContainerTypes([]);
            setFetchingContainerTypes(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const viewContainer = (parameters) => {
        setViewingContainer(true);

        ContainerService.viewContainer(parameters).then((res) => {
            console.log("viewContainer data xxxx", res);

            if (res.data.success) {
                setViewingContainer(false);
                setContainerDetails(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching container details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setContainerDetails(null);
            setViewingContainer(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateContainerStatus = (parameters) => {
        setUpdatingContainerStatus(true);

        ContainerService.updateContainerStatus(parameters).then((res) => {
            console.log("updateContainerStatus data xxxx", res);

            if (res.data.success) {
                setUpdatingContainerStatus(false);
                setContainerStatusUpdated(true);

                enqueueSnackbar("Successfully updated container status", {
                    variant: "success",
                    autoHideDuration: 3500
                });
            } 

        }).catch((error) => {
            console.error("Error updating container status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setContainerStatusUpdated(false);
            setUpdatingContainerStatus(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getContainerStatusList = () => {
        setFetchingContainerStatusList(true);

        ContainerService.getContainerStatusList().then((res) => {
            console.log("getContainerStatusList data xxxx", res);

            if (res.data.success) {
                setFetchingContainerStatusList(false);
                setContainerStatusList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching container status list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setContainerStatusList([]);
            setFetchingContainerStatusList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateContainer = (payload, isForm, orgIdFromUrlForPortEmployee) => {
        setUpdatingContainerStatus(true);
        setUpdatingContainer(true);

        ContainerService.updateContainer(payload).then((res) => {
            console.log("updateContainer data xxxx", res);

            if (res.data.success) {
                if (isForm) {
                    setUpdatingContainer(false);
                    enqueueSnackbar("Successfully updated container", {
                        variant: "success",
                        autoHideDuration: 3500
                    });

                    if (orgIdFromUrlForPortEmployee) {
                        navigate(`/organization/view/containers/view?org_uid=${res.data.data.org_uid}&id=${res.data.data.container_uid}`);

                    } else {
                        navigate(`/containers/view?id=${res.data.data.container_uid}`);
                    }
                }
            } 

        }).catch((error) => {
            console.error("Error updating container:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingContainerStatus(false);
            setContainerStatusUpdated(false);
            setUpdatingContainer(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const filterContainer = (parameters) => {
        setFilteringContainer(true);
    
        ContainerService.filterContainer(parameters).then((res) => {
            console.log("filterContainer data xxxx", res);
    
            if (res.data.success) {
                setFilteringContainer(false);
                setContainerListWithPagination(res.data.data);
            } 
    
        }).catch((error) => {
            console.error("Error filtering container list:", error);
            const errorMessage = error?.response?.data?.error || error.message;
    
            setContainerListWithPagination(null);
            setFilteringContainer(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }


    return {
        isFetchingContainerList,
        containerList,
        getListContainer,

        isListingContainer,
        containerListWithPagination,
        getListContainerWithPagination,

        isCreatingContainer,
        createContainer,

        isFetchingContainerTypes,
        containerTypes,
        getContainerTypes,

        isViewingContainer,
        containerDetails,
        viewContainer,

        isUpdatingContainerStatus,
        updateContainerStatus,

        isFetchingContainerStatusList,
        containerStatusList,
        getContainerStatusList,

        isUpdatingContainer,
        updateContainer,

        isFilteringContainer,
        filterContainer
    }
}

export default useContainer